import { FC } from "react"
import { Badge } from "./ui/badge"
import { Activity, BadgeQuestionMark, Construction, Unplug } from "lucide-react"
import { DeviceDTOStatusEnum } from "@/gen/api"

const convertIcon = (status: DeviceDTOStatusEnum) => {
  switch (status) {
    case DeviceDTOStatusEnum.Active:
      return <Activity className="size-3 mr-1" />
    case DeviceDTOStatusEnum.Inactive:
      return <Unplug className="size-3 mr-1" />
    case DeviceDTOStatusEnum.Maintenance:
      return <Construction className="size-3 mr-1" />
    default:
      return <BadgeQuestionMark className="size-3 mr-1" />
  }
}

const convertStatus = (status: DeviceDTOStatusEnum) => {
  switch (status) {
    case DeviceDTOStatusEnum.Active:
      return "Active"
    case DeviceDTOStatusEnum.Inactive:
      return "Inactive"
    case DeviceDTOStatusEnum.Maintenance:
      return "Maintenance"
    default:
      return "Unknown"
  }
}

const DeviceStatus: FC<{ status: DeviceDTOStatusEnum }> = ({ status }) => {
  return (
    <Badge variant="secondary" className="mt-2">
      {convertIcon(status)}
      {convertStatus(status)}
    </Badge>
  )
}

export default DeviceStatus
